import React from "react";
import { Box, Grid, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { size, COLORS } from "../../utils";

export default function Gallery() {
  const folders = [
    {
      label: "Workspace",
      path: "workspace",
      images: [
        "/assets/images/gallery/ClassRoom.jpg",
        "/assets/images/gallery/FrontOffice.jpg",
        "/assets/images/gallery/Lab1.jpg",
      ],
    },
    {
      label: "Collaborations",
      path: "collaborations",
      images: [
        "/assets/images/gallery/Logo.jpg",
        "/assets/images/gallery/PECWorkshopPoster.jpg",
        "/assets/images/gallery/PECWorkshop1.jpg",
      ],
    },
    {
      label: "Celebrations",
      path: "celebrations",
      images: [
        "/assets/images/gallery/Gen8Year1.jpg",
        "/assets/images/gallery/AyudhaPooja2.jpg",
        "/assets/images/gallery/Cake8Year.jpg",
      ],
    },
  ];

  return (
    <Grid
      container
      direction="column"
      alignItems="center"
      mt={size({ p: 10, h: true })}
      rowGap={size({ p: 8, h: true })}
    >
      <Typography
        sx={{
          fontSize: size({ p: 2.2 }),
          fontWeight: 600,
          color: COLORS.C2,
          textAlign: "center",
          fontFamily: "Archia",
        }}
      >
        Capturing Moments, Creating Milestones.
      </Typography>

      <Typography
        sx={{
          width: size({ p: 60 }),
          fontSize: size({ p: 0.9 }),
          fontWeight: 500,
          color: COLORS.C1 + "A0",
          textAlign: "center",
          fontFamily: "Archia",
          mt: "-4rem",
          padding: `0px ${size({ p: 10 })}`,
        }}
      >
       Meet the brilliant minds powering innovation and shaping your next breakthrough at Genesys — driven by passion and expertise.
      </Typography>

      <Grid
        sx={{
          display: "flex",
          gap: "3rem",
          flexWrap: "wrap",
          justifyContent: "center",
        }}
      >
        {folders.map((folder, i) => (
          <PolaroidTile key={i} {...folder} />
        ))}
      </Grid>
    </Grid>
  );
}

const PolaroidTile = ({ label, path, images }) => {
  const navigate = useNavigate();

  return (
    <Box textAlign="center" sx={{ cursor: "pointer", mr:'6rem' }} onClick={() => navigate(`/gallery/${path}`)}>
      {/* --- Polaroid Carousel --- */}
      <Box
        sx={{
          position: "relative",
          width: "240px",
          height: "260px",
          margin: "auto",
          perspective: "1000px",
          "& img": {
            position: "absolute",
            width: "240px",
            height: "260px",
            objectFit: "cover",
            border: "12px solid white",
            borderBottom: "40px solid white",
            borderRadius: "8px",
            boxShadow: "0 12px 25px rgba(0,0,0,0.25)",
            transition: "all 0.4s ease",
            transformStyle: "preserve-3d",
          },
          "& .left, & .right": { transformOrigin: "bottom center" },
          "& .left": {
            left: "-40px",
            top: "5px",
            transform: "rotateY(-10deg) rotateZ(-3deg)",
            zIndex: 1,
            opacity: 0.8,
          },
          "& .center": {
            left: "50%",
            top: 0,
            transform: "translateX(-50%) rotateY(0deg) rotateZ(0deg)",
            zIndex: 2,
            opacity: 1,
          },
          "& .right": {
            right: "-40px",
            top: "5px",
            transform: "rotateY(10deg) rotateZ(3deg)",
            zIndex: 1,
            opacity: 0.8,
          },
          "&:hover .center": {
            transform: "translateX(-50%) rotateY(0deg) rotateZ(0deg) scale(1.08)",
            boxShadow: "0 20px 35px rgba(0,0,0,0.3)",
            zIndex: 3,
          },
          "&:hover .left": {
            transform: "rotateY(-20deg) rotateX(5deg) rotateZ(-3deg)",
          },
          "&:hover .right": {
            transform: "rotateY(20deg) rotateX(5deg) rotateZ(3deg)",
          },
        }}
      >
        <Box component="img" src={images[0]} alt={`${label} left`} className="left" />
        <Box component="img" src={images[1]} alt={`${label} center`} className="center" />
        <Box component="img" src={images[2]} alt={`${label} right`} className="right" />
      </Box>
      
      <Typography
        sx={{
          mt: "2rem",
          fontSize: "1.4rem",
          fontWeight: 600,
          fontFamily: "Archia",
          color: COLORS.C2,
        }}
      >
        {label}
      </Typography>
    </Box>
  );
};
